import api from 'utils/api';
import { mapStationName } from 'utils/helpers';
import constantCreator from 'utils/constantCreator';

const constant = constantCreator('app');

const LOAD_EXCHANGE_RATES = constant('LOAD_EXCHANGE_RATES', true);
const LOAD_ALL_STATIONS = constant('LOAD_ALL_STATIONS', true);

const initialState = {
  isLoadingExchangeRates: true,
  isStationsLoaded: false,
  exchangeRates: {},
  stations: {
    arl: [],
    mrt: [],
    bts: []
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_EXCHANGE_RATES.RESOLVED:
      return {
        ...state,
        isLoadingExchangeRates: false,
        exchangeRates: action.data.exchangeRates.rates,
      };
    case LOAD_ALL_STATIONS.RESOLVED:
      return {
        ...state,
        isStationsLoaded: true,
        stations: action.data
      };
    default:
      return state;
  }
};

export const actions = {
  getExchangeRates: () => ({
    type: LOAD_EXCHANGE_RATES,
    promise: api.get('/configs?keys=exchangeRates'),
  }),
  getAllStations: () => ({
    type: LOAD_ALL_STATIONS,
    promise: Promise.all([
      api.get('/configs/meeting-points?city=Bangkok&type=Airport Rail Link Station'),
      api.get('/configs/meeting-points?city=Bangkok&type=MRT Station'),
      api.get('/configs/meeting-points?city=Bangkok&type=BTS Station')
    ]).then(stations => ({
      data: {
        arl: mapStationName(stations[0].data),
        mrt: mapStationName(stations[1].data),
        bts: mapStationName(stations[2].data)
      }
    }))
  })
};



// WEBPACK FOOTER //
// ./src/modules/app.js